import { createTheme } from '@mui/material/styles';
import components from './overrides';
import palette from './palette';
import breakpoints from './breakpoints';

export default createTheme({
  palette,
  breakpoints,
  components,
  typography: {
    fontFamily: [
      'Poppins',
    ].join(','),
  },
});
